import { render, staticRenderFns } from "./HighlightedPrizeFramePicture.vue?vue&type=template&id=49076178&scoped=true&"
import script from "./HighlightedPrizeFramePicture.vue?vue&type=script&lang=js&"
export * from "./HighlightedPrizeFramePicture.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedPrizeFramePicture.vue?vue&type=style&index=0&id=49076178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49076178",
  null
  
)

export default component.exports